import { getCSSVariable, prefixEvent } from './helpers';

export const BrowserEvents = {
	lazyload: 'lazyload.refresh',
	resize: 'resize',
	page: {
		loaded: 'page.loaded',
		enter: 'page.enter',
		leave: 'page.leave',
		transition: 'page.transition',
	},
	transition: {
		start: prefixEvent('Transition', 'Start'),
		end: prefixEvent('Transition', 'End'),
		refresh: 'transition.refresh'
	},
	animation: {
		start: prefixEvent('Animation', 'Start'),
		end: prefixEvent('Animation', 'End'),
		refresh: 'animation.refresh'
	}
};

export const BrowserEventsPromises = {
	transition: {
		start: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.transition.start, resolve)),
		end: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.transition.end, resolve)),
	},
	animation: {
		start: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.animation.start, resolve)),
		end: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.animation.end, resolve)),
	}
};

export const Breakpoints = {
	xs: parseInt(getCSSVariable('--breakpoint-xs'), 10),
	sm: parseInt(getCSSVariable('--breakpoint-sm'), 10),
	md: parseInt(getCSSVariable('--breakpoint-md'), 10),
	lg: parseInt(getCSSVariable('--breakpoint-lg'), 10),
	xl: parseInt(getCSSVariable('--breakpoint-xl'), 10),
	Mobile: parseInt(getCSSVariable('--mobile-breakpoint'), 10),
	Menu: parseInt(getCSSVariable('--menu-breakpoint'), 10),
};

export const Elements = {
	get LoadingBar() {
		return document.querySelector('.loading-bar');
	},
	get LoadingOverlay() {
		return document.querySelector('.loading-overlay');
	},
	get MainWrapper() {
		return document.querySelector('.main-wrapper');
	},
	get PageWrapper() {
		return document.querySelector('.page-wrapper');
	},
	get MenuWrapper() {
		return document.querySelector('.menu-wrapper');
	},
	get HeaderWrapper() {
		return document.querySelector('.header-wrapper');
	},
};

export const $Elements = {
	window: jQuery(window),
	document: jQuery(document),
	html: jQuery('html'),
	body: jQuery('body'),
	LoadingBar: jQuery(Elements.LoadingBar),
	LoadingOverlay: jQuery(Elements.LoadingOverlay),
	MainWrapper: jQuery(Elements.MainWrapper),
	PageWrapper: jQuery(Elements.PageWrapper),
	MenuWrapper: jQuery(Elements.MenuWrapper),
	HeaderWrapper: jQuery(Elements.HeaderWrapper),
};

export const Classes = {
	active: 'active',
	leaving: 'leaving',
	loading: 'loading',
	loaded: 'loaded',
	hidden: 'd-none',
	invisible: 'invisible',
	show: 'show',
	menuOpen: 'menu-open',
	menuLight: 'menu-light'
};

export const TransitionDurations = {
	default: parseInt(getCSSVariable('--default-transition-duration'), 10),
	page: parseInt(getCSSVariable('--page-transition-duration'), 10),
};

export const TransitionnableLinks = 'a:not([target="_blank"]):not([href*="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([download]):not([href=""]):not([hreflang]):not([target="lightbox"]):not([target^="lightbox-gallery"])';

export const MapTiles = {
	url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png',
	options: {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
		subdomains: 'abcd'
	}
};
